import { CoffeeOffOutlineIcon } from './CoffeeOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id B8D17AA8-7B65-4CA7-B9A9-6960C2A64164
 * name coffee-off-outline
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/coffee-off-outline.svg
 * tags
 * - Food / Drink 
 */
export const DrinkOffOutlineIcon = CoffeeOffOutlineIcon;
export default DrinkOffOutlineIcon